import queryString from 'query-string';

import { apiCreateTmpStorage } from '#/api/tmpStorage/apiCreateTmpStorage';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import type { AuthApiTmpStorage } from '#/modules/auth/api/tmpStorage/types/AuthApiTmpStorage';

import { generateRedirectUrl } from './temporaryStorage';

type ThirdPartyLoginProvider = 'facebook' | 'google' | 'apple';

type Args = {
  provider: ThirdPartyLoginProvider;
  redirectTo: string | null | undefined;
  inviteId?: string | null | undefined;
  tmpStorage?: AuthApiTmpStorage;
  locale: I18nLocale;
};

type ThirdPartyLoginQueryParams = {
  provider: ThirdPartyLoginProvider;
  invite?: string;
  to?: string;
};

export async function getThirdPartyLoginUrl({
  provider,
  redirectTo,
  inviteId,
  tmpStorage,
  locale,
}: Args) {
  const queryParams: ThirdPartyLoginQueryParams = { provider };

  if (inviteId) {
    queryParams.invite = inviteId;
  }

  const tmpId = tmpStorage ? await apiCreateTmpStorage(tmpStorage) : null;

  if (tmpId !== null) {
    const redirectToWithTmpId = generateRedirectUrl(
      redirectTo ?? `/${locale}`,
      tmpId,
    );
    queryParams.to = redirectToWithTmpId;
  } else if (redirectTo) {
    queryParams.to = redirectTo;
  }

  return `/third-party-login?${queryString.stringify(queryParams)}`;
}
